import env from '~/libs/env'
import get from 'lodash/get'
import { useErcStore } from '~/store/erc'
import { useUserStore } from '~/store/user'
import { useRootStore } from '~/store/root';

// DEPENDS ON auth.global.js running first
// list of route prefixes that erc redirect should not interfere with
const ignoredPaths = [
  '/erc',
  '/login',
  '/resume-app',
  '/sso-signup'
];

export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp()
  const { $pinia } = nuxtApp
  const ercStore = useErcStore($pinia)
  useUserStore($pinia)

  if (
    env('ercOnly') === 'true'
    && !ignoredPaths.some(path => to.path.startsWith(path))
  ) {
    const path = !!get(useRootStore($pinia), 'authUser.id')
      ? '/resume-app?type=erc'
      : '/erc';
    return nuxtApp.runWithContext(() => navigateTo(path))
  }

  const alreadyOnErcFinal = to.path === '/erc/final-erc-affiliate'
  const inErcApp = to.path && to.path.startsWith('/erc')
  if (!alreadyOnErcFinal && inErcApp && !!get(useRootStore($pinia), 'authUser.id')) {
    // TODO: Find better way to pass contexted redirect function
    await ercStore.redirectToErcFinal(to, navigateTo);
  }
})
